import classes from './Card.module.css'

const Card = ({children, type, overflow, border}) => {
    return <div className={`${classes.card} ${type ? classes[type] : ''}`} style={{overflow: overflow, border: border}}>{children}</div>
}

export default Card